import { supabase } from '../supabase';
import { Trophy, Zap, Clock, Timer, Smile, BookOpen, HeartHandshake, Award } from 'lucide-react';

export const BADGE_DEFS = [
  { tipo: 'pontualidade_britanica', Icon: Trophy,        nome: 'Pontualidade Britânica', desc: 'Devolveu no prazo nas últimas 5 vezes',              cor: 'bg-yellow-50 text-yellow-700 border-yellow-200' },
  { tipo: 'relampago',              Icon: Zap,           nome: 'Relâmpago',              desc: 'Devolveu sem atrasos pelo menos 3 vezes',            cor: 'bg-blue-50 text-blue-700 border-blue-200' },
  { tipo: 'confiavel',              Icon: Clock,         nome: 'Confiável',              desc: 'Sempre comunicou quando foi atrasar',                 cor: 'bg-green-50 text-green-700 border-green-200' },
  { tipo: 'tartaruga',              Icon: Timer,         nome: 'Tartaruga',              desc: 'Atrasou mais de 3 vezes',                            cor: 'bg-orange-50 text-orange-700 border-orange-200' },
  { tipo: 'quase_la',               Icon: Smile,         nome: 'Quase lá',               desc: 'Atrasou mas sempre avisou',                          cor: 'bg-pink-50 text-pink-700 border-pink-200' },
  { tipo: 'leitor_voraz',           Icon: BookOpen,      nome: 'Leitor Voraz',           desc: 'Mais de 10 livros emprestados',                      cor: 'bg-purple-50 text-purple-700 border-purple-200' },
  { tipo: 'parceiro',               Icon: HeartHandshake,nome: 'Parceiro',               desc: 'Avaliou mais de 5 empréstimos',                      cor: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  { tipo: 'favorito',               Icon: Award,         nome: 'Favorito',               desc: 'Aprovado em 100% das solicitações (mín. 5)',          cor: 'bg-amber-50 text-amber-700 border-amber-200' },
];

export async function calcularEAtribuirBadges(userId) {
  const { data: raw, error: errEmp } = await supabase
    .from('emprestimos')
    .select('id, status, leitor_avisou_atraso, prorrogacao_solicitada, leitor_feedback_estrelas, leitor_feedback_comentario')
    .eq('leitor_user_id', userId);
  if (errEmp) { if (process.env.NODE_ENV !== 'production') console.error('calcularBadges:', errEmp.message); return []; }

  const todos = raw || [];
  const devolvidos = todos.filter(e => e.status === 'devolvido');
  const semAtraso  = devolvidos.filter(e => !e.leitor_avisou_atraso && !e.prorrogacao_solicitada);
  const comAtraso  = devolvidos.filter(e => e.leitor_avisou_atraso  ||  e.prorrogacao_solicitada);
  const ultimos5   = devolvidos.slice(-5);
  const comFeedback = devolvidos.filter(e => e.leitor_feedback_estrelas || e.leitor_feedback_comentario);
  const concluidos = todos.filter(e => ['aprovado', 'devolvido', 'recusado'].includes(e.status));
  const aprovadas  = concluidos.filter(e => e.status !== 'recusado');

  const ganhos = new Set();

  if (ultimos5.length === 5 && ultimos5.every(e => !e.leitor_avisou_atraso && !e.prorrogacao_solicitada))
    ganhos.add('pontualidade_britanica');

  if (semAtraso.length >= 3)
    ganhos.add('relampago');

  if (devolvidos.length >= 3 && !comAtraso.some(e => !e.leitor_avisou_atraso))
    ganhos.add('confiavel');

  if (comAtraso.length > 3)
    ganhos.add('tartaruga');

  if (comAtraso.length > 0 && comAtraso.every(e => e.leitor_avisou_atraso))
    ganhos.add('quase_la');

  if (todos.length > 10)
    ganhos.add('leitor_voraz');

  if (comFeedback.length > 5)
    ganhos.add('parceiro');

  if (concluidos.length >= 5 && aprovadas.length === concluidos.length)
    ganhos.add('favorito');

  const { data: existentes, error: errEx } = await supabase
    .from('badges').select('tipo').eq('user_id', userId);
  if (errEx && process.env.NODE_ENV !== 'production') console.error('calcularBadges (existentes):', errEx.message);
  const jaExiste = new Set((existentes || []).map(b => b.tipo));

  const novos = [...ganhos].filter(t => !jaExiste.has(t));
  if (novos.length > 0) {
    const defs = BADGE_DEFS.filter(d => novos.includes(d.tipo));
    await supabase.from('badges').insert(
      defs.map(d => ({ user_id: userId, tipo: d.tipo, descricao: d.desc }))
    );
  }

  return [...ganhos];
}

export async function buscarBadges(userId) {
  const { data, error } = await supabase
    .from('badges').select('*').eq('user_id', userId)
    .order('created_at', { ascending: true });
  if (error && process.env.NODE_ENV !== 'production') console.error('buscarBadges:', error.message);
  return (data || []).map(b => {
    const def = BADGE_DEFS.find(d => d.tipo === b.tipo);
    return def ? { ...b, ...def } : null;
  }).filter(Boolean);
}
